import React from 'react';
import { ShimmerTitle } from "react-shimmer-effects";
import { BaseCard } from '../commonComponents';


const ResourceDocumentLoader = () => {
  return (
    <BaseCard customBaseCardStyle='rounded-3 mg-t-20 pd-15'>
        <div className='d-flex justify-content-between'>
          <div style={{ width: '40%' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block" /></div>
          <div style={{ width: '20%' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block" /></div>
        </div>
        <ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 mg-t-10 d-block" />
        <ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 mg-t-10 d-block" />
    </BaseCard>
  );
};

export default ResourceDocumentLoader;
